import React from 'react';

import PropTypes from 'prop-types';
import cn from 'classnames';
import { BiCheck } from 'react-icons/bi';

import EmptyState from 'modules/common/components/EmptyState';
import { FormCreateButtons } from 'modules/common';
import { useGetExtraCharges } from 'modules/branch/services-management/settings/hooks';
import PageLoader from 'modules/common/components/PageLoader';
import { formatCurrency } from 'modules/common/utils';

const DEFAULT_FILTER = {};

function ChargesModal({ onClose, onChange, name, value }) {
  const [form, setForm] = React.useState([]);

  const [isLoading, list] = useGetExtraCharges({
    params: DEFAULT_FILTER,
  });

  const handleOnCheck = (row) => {
    const existsIndx = form?.findIndex((item) => item?.uuid === row?.uuid);

    if (existsIndx > -1) {
      setForm((prevState) =>
        prevState?.filter((item) => item?.uuid !== row?.uuid)
      );
      return;
    }

    setForm((prevState) => [...prevState, row]);
  };

  const onSubmitClick = () => {
    onChange(() => ({
      [name]: form,
    }));
    onClose();
  };

  React.useEffect(() => {
    setForm(value);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(value)]);

  if (isLoading && list?.length <= 0) return <PageLoader />;

  return (
    <div>
      <div className="min-h-[300px] max-h-[300px] overflow-y-auto overflow-x-hidden space-y-3">
        {list?.length > 0 ? (
          list?.map((item, key) => {
            const k = key;
            const existsIndx = form?.findIndex(
              (subItem) => subItem?.uuid === item?.uuid
            );

            return (
              <button
                key={k}
                type="button"
                onClick={() => handleOnCheck(item)}
                className={cn(
                  'card p-3 font-medium flex items-center gap-2 cursor-pointer text-sm w-full text-left',
                  {
                    '!bg-primary-50 !border-primary-500': existsIndx > -1,
                  }
                )}
              >
                <div className="w-8 h-7">
                  {existsIndx > -1 && (
                    <BiCheck className="h-7 w-7 text-primary-500" />
                  )}
                </div>
                <div className="flex flex-1 gap-3">
                  <div className="flex-1">{item?.name}</div>
                  <div>+ {formatCurrency(item?.value)}</div>
                </div>
              </button>
            );
          })
        ) : (
          <EmptyState />
        )}
      </div>

      <FormCreateButtons
        onCancel={onClose}
        isInsidePageHeader
        primaryButtonProps={{
          label: 'Proceed',
        }}
        onSubmit={onSubmitClick}
      />
    </div>
  );
}

export default ChargesModal;

ChargesModal.defaultProps = {
  onClose: () => {},
  onChange: () => {},
  value: [],
};

ChargesModal.propTypes = {
  onClose: PropTypes.instanceOf(Function),
  onChange: PropTypes.instanceOf(Function),
  name: PropTypes.string.isRequired,
  value: PropTypes.instanceOf(Array),
};
